import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchMarcas,
    fetchCategorias,
} from '../../../../actions/publicacionesActions';
import { fetchMarcaApi, fetchCategoriaApi } from '../../../../api/axios';
import { DropDownArrow } from "../../../../template/CustomStyle";
import { customStyle } from '../../../../template/CustomStyle';
import DescripcionAmpliada from './DescripcionAmpliada';
import { toast } from 'react-toastify';

class DatosBasicos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            marca: { label: '', value: '' },
            categoria: { label: '', value: '' },
            dimensiones: [],
            isCreated: true
        }
    };

    componentDidMount = () => {
        if (this.state.isCreated && this.props.publicacion?.marca && this.props.publicacion?.categoria) {
            this.setMarca(this.props.publicacion.marca);
            this.setCategoria(this.props.publicacion.categoria);
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.publicacion.marca || nextProps.publicacion.categoria) {
            if (this.state.marca.value !== nextProps.publicacion.marca) this.setMarca(nextProps.publicacion.marca);
            if (this.state.categoria.value !== nextProps.publicacion.categoria) this.setCategoria(nextProps.publicacion.categoria)
        }
    }

    setMarca = (marcaId) => {
        if (!marcaId) {
            toast.error("No se puede obtener la marca");
            return;
        }
        const req = fetchMarcaApi(marcaId);
        req.then((response) => {
            this.setState({
                marca: {
                    label: response.marca.descripcion,
                    value: response.marca.codigo
                },
                isCreated: false
            })
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No se puede obtener la marca");
        });
    }

    setCategoria = (categoriaId) => {
        const req = fetchCategoriaApi(categoriaId);
        req.then((response) => {
            this.setState({
                categoria: { label: response.subFamilia.descripcion, value: response.subFamilia.codigo },
                isCreated: false
            })
        }).catch(err => console.log());
    }

    onSelectSearchInputCategorias = (descripcion) => {
        this.props.fetchCategorias(descripcion);
    }

    onSelectSearchInputMarcas = (descripcion) => {
        this.props.fetchMarcas(descripcion);
    }

    myChangeHandler = (event) => {
        const { name, value } = event.target;
        let newValue = (name == "stock") ? parseInt(value) : value;
        let publicacion = { ...this.props.publicacion };
        publicacion[name] = newValue;
        this.props.editPublicacion(publicacion);
    }

    selectSearchHandler = (options, config) => {
        let publicacion = { ...this.props.publicacion };
        publicacion[config.name] = options.value;
        this.props.editPublicacion(publicacion);
        this.setState({ [config.name]: options });
    }

    agregarFila = () => {
        let element = { alto: 0, ancho: 0, profundidad: 0, peso: 0 }
        this.props.dimensiones.push(element)
        this.forceUpdate();
    }

    borrarFila = (position) => {
        this.props.dimensiones.splice(position, 1);
        this.forceUpdate();
    }

    changeSku = (event) => {
        let value = event.target.value;
        if (value.length <= 30) {
            let publicacion = { ...this.props.publicacion };
            publicacion[event.target.name] = event.target.value;
            this.props.editPublicacion(publicacion);
        }
    }

    changeDimensionFormat = (num) => {
        let formatted = num.replace(/^(\d{3})(\d{1}).*/, '$1.$2');
        return formatted.substring(0, 6);
    }

    changeDimensions = (event) => {
        const { name, value } = event.target;
        let valor = this.changeDimensionFormat(value);
        let index = name.replace(/\D/g, "");

        if (name.includes("alto")) this.props.dimensiones[index].alto = valor;
        if (name.includes("ancho")) this.props.dimensiones[index].ancho = valor;
        if (name.includes("profundidad")) this.props.dimensiones[index].profundidad = valor;
        if (name.includes("peso")) this.props.dimensiones[index].peso = valor;

        let publicacion = { ...this.props.publicacion, dimensiones: this.props.dimensiones };
        this.props.editPublicacion(publicacion);
    }


    render() {
        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">

                        <div className="form-group">
                            <label>Nombre Producto</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.props.publicacion.titulo}
                                onChange={this.myChangeHandler}
                                name="titulo"
                            />
                        </div>

                        <div className="form-group">
                            <label>EAN</label>
                            <input
                                className="form-control"
                                name="ean"
                                value={this.props.publicacion.ean}
                                onChange={this.myChangeHandler}
                                type="number"
                                min="0"
                                maxLength="13"
                            />
                        </div>

                        <div>
                            <label>Categoria</label>
                            <Select
                                name="categoria"
                                value={this.state.categoria}
                                options={this.props.categorias}
                                onChange={this.selectSearchHandler}
                                onInputChange={this.onSelectSearchInputCategorias}
                                styles={customStyle}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                            />
                        </div>

                        <div>
                            <label>Marca</label>
                            <Select
                                name="marca"
                                value={this.state.marca}
                                options={this.props.marcas}
                                onChange={this.selectSearchHandler}
                                onInputChange={this.onSelectSearchInputMarcas}
                                styles={customStyle}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                className={"form-material"}
                            />
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-6 col-lg-6">

                        <div className="form-group">
                            <label>Stock</label>
                            <input
                                className="form-control"
                                value={this.props.publicacion.stock}
                                onChange={this.myChangeHandler}
                                name="stock"
                                maxLength="4"
                                min="0"
                                type="number"
                            />
                        </div>

                        <div className="form-group">
                            <label>SKU Seller</label>
                            <input
                                className="form-control"
                                name="skuSeller"
                                value={this.props.publicacion.skuSeller}
                                onChange={this.changeSku}
                            />
                        </div>

                        <div className="form-group">
                            <label>Sku Market</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.props.publicacion.skuMarket}
                                name="skuMarket"
                                disabled
                            />
                        </div>
                    </div>

                    <div className="col-12 table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Alto (cm)</th>
                                    <th>Ancho (cm)</th>
                                    <th>Profundidad (cm)</th>
                                    <th>Peso (kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props?.dimensiones &&
                                    this.props.dimensiones.map((item, numeroFila) => {
                                        return (
                                            <tr className="hover-background-color" key={numeroFila}>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        name={"alto" + numeroFila}
                                                        value={item.alto}
                                                        type="number"
                                                        min="0"
                                                        onChange={this.changeDimensions}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        name={"ancho" + numeroFila}
                                                        value={item.ancho}
                                                        type="number"
                                                        min="0"
                                                        onChange={this.changeDimensions}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        name={"profundidad" + numeroFila}
                                                        value={item.profundidad}
                                                        type="number"
                                                        min="0"
                                                        onChange={this.changeDimensions}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        name={"peso" + numeroFila}
                                                        value={item.peso}
                                                        type="number"
                                                        min="0"
                                                        onChange={this.changeDimensions}
                                                    />
                                                </td>
                                                {!this.props.userType.isAdminMod &&
                                                    <td onClick={() => this.borrarFila(numeroFila)}>
                                                        <i className="fas fa-trash-alt" />
                                                    </td>
                                                }
                                                {!this.props.userType.isAdminMod &&
                                                    <td onClick={() => this.agregarFila()}>
                                                        <i className="fas fa-plus" />
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="form-group my-4">
                    <label>Descripción Ampliada</label>
                    <DescripcionAmpliada />
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    dimensiones: state.publicaciones.dimensiones,
    categorias: state.publicaciones.categorias,
    marcas: state.publicaciones.marcas
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchMarcas,
    fetchCategorias
})(DatosBasicos);